import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchSupplier from '../components/Search/SearchSupplier';

import CustomScrollbars from './CustomScrollbars';

class InWorkPanel extends Component {
	render () {
		const { title, list } = this.props;
		return (
			<div className="col-xs-12 panel panel-info">
				<div className="panel-heading">
					<h4 className="panel-title">{title}</h4>
				</div>
				<div className="panel-body">
					<CustomScrollbars autoHeight autoHeightMin={150} autoHeightMax={150}>
						<div className="row">
							<div className="col-xs-12">
								<h4>Поставщики</h4>
								{list.supplier ? list.supplier.map(client =>
									<SearchSupplier key={ client.id } client={ client }/>) : null}
							</div>
						</div>
					</CustomScrollbars>
				</div>
			</div>
		);
	}
}

InWorkPanel.propTypes = {
	list: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired]),
	title: PropTypes.string.isRequired
};

export default InWorkPanel;


// WEBPACK FOOTER //
// ./components/InWorkPanel.js